export default __webpack_public_path__ + "static/media/entry-menu.3ca86739.jpeg";